import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import App from './App';
import CallsPage from './pages/CallsPage';
import AdminLayout from './pages/admin/AdminLayout';
import UsersPage from './pages/admin/UsersPage';
import DevicesPage from './pages/admin/DevicesPage';
import AgentsPage from './pages/admin/AgentsPage';
import DeploymentLocationsPage from './pages/admin/DeploymentLocationsPage';
import './styles/global.css';
import '@livekit/components-styles';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />, 
    children: [
      { index: true, element: <CallsPage /> },
      { path: 'calls', element: <CallsPage /> },
      {
        path: 'admin',
        element: <AdminLayout />,
        children: [
          { index: true, element: <UsersPage /> },
          { path: 'users', element: <UsersPage /> },
          { path: 'devices', element: <DevicesPage /> },
          { path: 'agents', element: <AgentsPage /> },
          { path: 'locations', element: <DeploymentLocationsPage /> },
        ],
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
